import React, {Component} from "react";
import mockups from '../images/image-mockups.png';

class Hero extends Component{
    render(){
        return(
            <React.Fragment>
                    <section className="hero">
                        <div className="container">
                            <div className="hero-text">
                                <h1>Next generation digital banking</h1>
                                <p>Take your financial life online. Your Easybank account will be a one-stop-shop 
                                for spending, saving, budgeting, investing, and much more.</p>
                                <button type="button" className="req">Request Invite</button>
                            </div>

                            <div className="hero-image">
                                <div className="image">
                                    <img src={mockups} alt="Easy Bank App Screens" />
                                </div>
                            </div>
                        </div>
                    </section>
            </React.Fragment>
        );
    }
}

export default Hero;